import CustomPageContainer from '@components/CustomPageContainer';
import { TaggedEditButton, TaggedUploadButton } from '@components/actionsButtons';
import ContentContainer from '@components/contentContainer/ContentContainer';
import useModal from '@hooks/useModal';
import {
  Alert, Col, Row, Space, Table, Typography,
} from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useState } from 'react';
import UpdateCommentTemplateModal from '../../../modalHouse/modals/comment/UpdateCommentTemplateModal';
import UploadMultipleCommentsExcelModal from '../../../modalHouse/modals/comment/UploadMultipleCommentsExcelModal';
import { useCommentTemplateList } from '../src/commentQueries';

const { Paragraph } = Typography;

const CommentTemplateList = () => {
  const { data, isLoading } = useCommentTemplateList();
  const { showModal, openModal, closeModal } = useModal();

  const [selectedTemplate, setSelectedTemplate] = useState<comment.CommentTemplateData>();

  const {
    showModal: showUploadMultipleCommentsExcelModal,
    openModal: openUploadMultipleCommentsExcelModal,
    closeModal: closeUploadMultipleCommentsExcelModal,
  } = useModal();

  const columns: ColumnsType<comment.CommentTemplateData> = [
    { title: 'ID', dataIndex: 'id' },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Description', dataIndex: 'description' },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      align: 'center',
      fixed: 'right',
      className: 'whitespace-nowrap',
      render: (value, record) => (
        <TaggedEditButton
          tooltiptext="Edit comment template"
          tag="editCommentTemplate"
          onClick={() => {
            setSelectedTemplate(record);
            openModal();
          }}
        />
      ),
    },
  ];

  return (
    <CustomPageContainer breadcrumbName="Comment Template List">
      <ContentContainer>
        <Space direction="vertical" size="middle">
          <Alert
            message="Notes:"
            description={(
              <Paragraph>
                <ul>
                  <li>
                    MD = Maturity Date
                  </li>
                  <li>
                    The
                    <strong> Zero Profit Comment </strong>
                    won&apos;t be triggered even though the profit return is zero when the note status is:
                    <ul>
                      <li>Defaulted</li>
                      <li>Recovered (Partial)</li>
                      <li>Recovered</li>
                      <li>Write off</li>
                      <li>Write back</li>
                      <li>Write back (Partial)</li>
                    </ul>
                  </li>
                </ul>
              </Paragraph>
            )}
            type="info"
            showIcon
          />
          <Row justify="end" gutter={8}>
            <Col>
              <TaggedUploadButton
                tag="uploadMultipleComments"
                onClick={openUploadMultipleCommentsExcelModal}
                tooltiptext="Bulk upload comments for investment notes"
              >
                Upload Multiple Comments Excel
              </TaggedUploadButton>
            </Col>
          </Row>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            pagination={{ hideOnSinglePage: true }}
            rowClassName={(record, index) => (index % 2 === 0 ? 'dark-stripe' : '')}
          />
        </Space>
        {selectedTemplate && <UpdateCommentTemplateModal showModal={showModal} closeModal={closeModal} selectedTemplate={selectedTemplate} />}
      </ContentContainer>

      <UploadMultipleCommentsExcelModal
        closeModal={closeUploadMultipleCommentsExcelModal}
        showModal={showUploadMultipleCommentsExcelModal}
      />
    </CustomPageContainer>
  );
};

export default CommentTemplateList;
